:host {
  display: block;
}

.avatar {
  display: flex;
  font-family: var(--dc-font-family);
  color: var(--dc-primary-text-color);
}

.avatar a {
  color: var(--dc-primary-text-color);
  text-decoration: none;
}

.avatar-image img,
.avatar-initial {
  height: 48px;
  width: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--dc-primary-colour);
  color: var(--dc-primary-token-text-color);
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
}

.avatar-details {
  margin-left: 12px;
}

.avatar-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.avatar-name {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
